import React from 'react';
import Svg from '../Svg';

const IconWebcam02 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C7.85786 3 4.5 6.35786 4.5 10.5C4.5 14.6421 7.85786 18 12 18C16.1421 18 19.5 14.6421 19.5 10.5C19.5 6.35786 16.1421 3 12 3ZM2.5 10.5C2.5 5.25329 6.75329 1 12 1C17.2467 1 21.5 5.25329 21.5 10.5C21.5 15.7467 17.2467 20 12 20C6.75329 20 2.5 15.7467 2.5 10.5ZM12 8.3125C10.7919 8.3125 9.8125 9.29188 9.8125 10.5C9.8125 11.7081 10.7919 12.6875 12 12.6875C13.2081 12.6875 14.1875 11.7081 14.1875 10.5C14.1875 9.29188 13.2081 8.3125 12 8.3125ZM7.8125 10.5C7.8125 8.18731 9.68731 6.3125 12 6.3125C14.3127 6.3125 16.1875 8.18731 16.1875 10.5C16.1875 12.8127 14.3127 14.6875 12 14.6875C9.68731 14.6875 7.8125 12.8127 7.8125 10.5ZM7 22C7 21.4477 7.44772 21 8 21H16C16.5523 21 17 21.4477 17 22C17 22.5523 16.5523 23 16 23H8C7.44772 23 7 22.5523 7 22Z"
    />
  </Svg>
);

export default IconWebcam02;
